// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import HallOfFameOutcomeContainer from '../containers/HallOfFameOutcomeContainer';

const OutcomeWrapper = styled.div``;

const HallOfFameBetslips = ({ betslipId, details, isSimpleBet, status }) => {
  return (
    <div>
      {details.map(({ outcomeId, odds }) => {
        return (
          // combo of `betslipId` + `outcomeId` otherwise we have a `key` warning
          <OutcomeWrapper key={`hof-betslips-${betslipId}-${outcomeId}`}>
            <HallOfFameOutcomeContainer status={status} odds={odds} id={outcomeId} isSimpleBet={isSimpleBet} />
          </OutcomeWrapper>
        );
      })}
    </div>
  );
};

export default HallOfFameBetslips;
